import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { routes } from './app.routes';

import { ScreenTrackingService, UserTrackingService, getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth, GoogleAuthProvider } from '@angular/fire/auth';

import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
//import { provideAnimations } from '@angular/platform-browser/animations';

import { ControllerService } from './services/controller/controller.service';

// Custom Date formats
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { CUSTOM_DATE_FORMATS } from './constants/date-formats';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    // Routes
    provideRouter(routes),
  
    // Http client (aquí sí va con importProvidersFrom porque es un NgModule)
    importProvidersFrom(HttpClientModule),
    
    // Firebase
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    //provideAnalytics(() => getAnalytics()), // solo si Analytics está configurado
    provideAuth(() => getAuth()),
    GoogleAuthProvider,
    
    // User interaction and animations
    ScreenTrackingService,
    UserTrackingService,
    provideAnimationsAsync(),
    //provideAnimations(),

    // Custom services
    ControllerService,
    //CookieService,


    // Custom date formats
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }

  ]
};
